import React from 'react';

import { SvgIcon } from '@mui/material';
import classNames from 'classnames';

import { useStyles } from '../Icon.styles';
import { LegacyIconProps } from '../Icon.types';

export const Laughing = ({
  size = 'default',
  color = 'secondary',
}: LegacyIconProps) => {
  const { classes } = useStyles();

  return (
    <SvgIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(
        classes[`icon_size_${size}` as const],
        classes[`icon_color_${color}` as const],
      )}
    >
      <g clipPath="url(#clip0_4706_230191)">
        <path
          d="M9.97265 17.0225C13.8559 17.0225 17.0039 13.8745 17.0039 9.99121C17.0039 6.10796 13.8559 2.95996 9.97265 2.95996C6.0894 2.95996 2.94141 6.10796 2.94141 9.99121C2.94141 13.8745 6.0894 17.0225 9.97265 17.0225Z"
          fill="url(#paint0_radial_4706_230191)"
        />
        <path
          d="M9.97265 17.0225C13.8559 17.0225 17.0039 13.8745 17.0039 9.99121C17.0039 6.10796 13.8559 2.95996 9.97265 2.95996C6.0894 2.95996 2.94141 6.10796 2.94141 9.99121C2.94141 13.8745 6.0894 17.0225 9.97265 17.0225Z"
          fill="url(#paint1_radial_4706_230191)"
        />
        <path
          d="M9.97558 17.0039C13.8588 17.0039 17.0068 13.8559 17.0068 9.97266C17.0068 6.0894 13.8588 2.94141 9.97558 2.94141C6.09233 2.94141 2.94434 6.0894 2.94434 9.97266C2.94434 13.8559 6.09233 17.0039 9.97558 17.0039Z"
          fill="url(#paint2_radial_4706_230191)"
          fillOpacity="0.8"
        />
        <path
          d="M9.97559 2.94141C6.09234 2.94141 2.94434 6.0894 2.94434 9.97265C2.94434 13.8559 6.09233 17.0039 9.97559 17.0039C13.8588 17.0039 17.0068 13.8559 17.0068 9.97266C17.0068 6.0894 13.8588 2.94141 9.97559 2.94141Z"
          fill="url(#paint3_radial_4706_230191)"
          fillOpacity="0.8"
        />
        <g
          style={{ mixBlendMode: 'multiply' }}
          opacity="0.8"
          filter="url(#filter0_f_4706_230191)"
        >
          <path
            d="M4.38663 11.7506C4.87237 11.0923 5.01186 9.62566 5.0498 9.00946C5.05928 8.85549 4.93547 8.731 4.78198 8.74637C4.39748 8.78488 3.68108 8.90498 3.03134 9.27929C3.0711 10.9199 3.35709 11.9527 3.49512 12.264C3.83918 12.2162 4.16177 12.0422 4.38663 11.7506Z"
            fill="url(#paint4_linear_4706_230191)"
          />
        </g>
        <g
          style={{ mixBlendMode: 'multiply' }}
          opacity="0.8"
          filter="url(#filter1_f_4706_230191)"
        >
          <path
            d="M15.6101 11.8037C15.1073 11.1223 14.9645 9.60038 14.9262 8.97043C14.9168 8.81646 15.0403 8.69182 15.1939 8.70691C15.5879 8.74563 16.3322 8.86834 17.0068 9.25696C16.9658 10.9477 16.6711 12.012 16.5288 12.3328C16.1743 12.2835 15.8418 12.1041 15.6101 11.8037Z"
            fill="url(#paint5_linear_4706_230191)"
          />
        </g>
        <path
          d="M11.091 7.01069C11.0643 6.53205 11.6641 6.23454 12.4477 6.10216C13.3196 5.95483 14.2863 6.15615 14.787 6.53515C14.9653 6.67038 14.8726 6.85909 14.7413 6.84165C13.9555 6.73809 12.8548 6.66052 12.1043 7.01069C12.4416 7.43275 13.2705 7.72705 13.7794 7.82029C13.9897 7.85873 14.0751 8.16584 13.8 8.21815C13.2915 8.31388 11.1237 7.60179 11.091 7.01069Z"
          fill="#50233C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.7997 8.21815C14.0748 8.16584 13.9894 7.85873 13.7791 7.82029C13.3451 7.74078 12.6784 7.51502 12.2823 7.1885C12.2139 7.13215 12.1536 7.0728 12.104 7.01069C12.1779 6.9762 12.2553 6.94585 12.3354 6.91927C13.0683 6.67605 14.0326 6.7483 14.741 6.84165C14.8723 6.85909 14.965 6.67038 14.7867 6.53515C14.286 6.15615 13.3193 5.95483 12.4474 6.10216C11.6638 6.23454 11.064 6.53205 11.0907 7.01069C11.1234 7.60179 13.2912 8.31388 13.7997 8.21815ZM10.8567 7.02374C10.8647 7.16747 10.9353 7.29017 11.0158 7.38652C11.0977 7.48455 11.2057 7.57429 11.3235 7.65531C11.5595 7.81764 11.8675 7.96668 12.1809 8.09007C12.496 8.21409 12.827 8.31622 13.1146 8.38155C13.2583 8.4142 13.3943 8.43837 13.5139 8.45107C13.6294 8.46332 13.7458 8.4668 13.8431 8.44848L13.8435 8.4484C13.9561 8.42698 14.06 8.37333 14.13 8.27939C14.1999 8.1856 14.2178 8.07595 14.2032 7.97916C14.1756 7.79565 14.0285 7.62762 13.8212 7.58974C13.5844 7.54634 13.2676 7.45477 12.9718 7.32434C12.8157 7.25552 12.6735 7.17938 12.5542 7.09886C12.8153 7.03047 13.109 6.99781 13.415 6.99033C13.8648 6.97932 14.3228 7.02295 14.7104 7.07402C14.906 7.09988 15.061 6.96853 15.1057 6.80873C15.1538 6.63666 15.0785 6.46231 14.9283 6.34841L14.9282 6.34827C14.6401 6.13027 14.236 5.97467 13.8004 5.8911C13.362 5.80699 12.8741 5.79235 12.4084 5.87106C12.0027 5.93958 11.6233 6.05376 11.3422 6.22706C11.06 6.401 10.8366 6.66363 10.8567 7.02374Z"
          fill="url(#paint6_linear_4706_230191)"
        />
        <path
          d="M8.88168 7.01069C8.90837 6.53205 8.30858 6.23454 7.52496 6.10216C6.65308 5.95483 5.68638 6.15615 5.18567 6.53515C5.00738 6.67038 5.10007 6.85909 5.23138 6.84165C6.01714 6.73809 7.11784 6.66052 7.86837 7.01069C7.53101 7.43275 6.70219 7.72705 6.1933 7.82029C5.98298 7.85873 5.89757 8.16584 6.17266 8.21815C6.68119 8.31388 8.84894 7.60179 8.88168 7.01069Z"
          fill="#50233C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.17294 8.21815C5.89785 8.16584 5.98326 7.85873 6.19358 7.82029C6.62758 7.74078 7.29427 7.51502 7.69036 7.1885C7.75871 7.13215 7.81901 7.0728 7.86866 7.01069C7.79472 6.9762 7.71739 6.94585 7.6373 6.91927C6.90433 6.67605 5.94002 6.7483 5.23167 6.84165C5.10035 6.85909 5.00766 6.67038 5.18595 6.53515C5.68666 6.15615 6.65336 5.95483 7.52524 6.10216C8.30887 6.23454 8.90865 6.53205 8.88196 7.01069C8.84922 7.60179 6.68148 8.31388 6.17294 8.21815ZM9.11597 7.02374C9.10799 7.16747 9.03738 7.29017 8.95685 7.38652C8.87491 7.48455 8.767 7.57429 8.64918 7.65531C8.41312 7.81764 8.10519 7.96668 7.79172 8.09007C7.47665 8.21409 7.14565 8.31622 6.85808 8.38155C6.71434 8.4142 6.5784 8.43837 6.45874 8.45107C6.34329 8.46332 6.22687 8.4668 6.12958 8.44848L6.12915 8.4484C6.01652 8.42698 5.91264 8.37333 5.84262 8.27939C5.77271 8.1856 5.7549 8.07595 5.76947 7.97916C5.79707 7.79565 5.94415 7.62762 6.15145 7.58974C6.38826 7.54634 6.70505 7.45477 7.00089 7.32434C7.15699 7.25552 7.29918 7.17938 7.4185 7.09886C7.15735 7.03047 6.86362 6.99781 6.55764 6.99033C6.10785 6.97932 5.64981 7.02295 5.26229 7.07402C5.06667 7.09988 4.91164 6.96853 4.86698 6.80873C4.81889 6.63666 4.89415 6.46231 5.04432 6.34841L5.0445 6.34827C5.33251 6.13027 5.7367 5.97467 6.17225 5.8911C6.61061 5.80699 7.09853 5.79235 7.56428 5.87106C7.96991 5.93958 8.34932 6.05376 8.63046 6.22706C8.91263 6.401 9.13605 6.66363 9.11597 7.02374Z"
          fill="url(#paint7_linear_4706_230191)"
        />
        <path
          d="M1.38221 9.11728C2.30526 8.08017 4.33612 7.32588 4.87362 7.80439C5.4244 8.29463 4.83182 10.4618 3.97479 11.4247C3.36034 12.1157 2.28143 12.1587 1.56541 11.5216C0.849398 10.8845 0.767366 9.80791 1.38182 9.11728H1.38221Z"
          fill="url(#paint8_radial_4706_230191)"
        />
        <path
          d="M1.38221 9.11728C2.30526 8.08017 4.33612 7.32588 4.87362 7.80439C5.4244 8.29463 4.83182 10.4618 3.97479 11.4247C3.36034 12.1157 2.28143 12.1587 1.56541 11.5216C0.849398 10.8845 0.767366 9.80791 1.38182 9.11728H1.38221Z"
          fill="url(#paint9_radial_4706_230191)"
        />
        <path
          d="M3.65867 9.48323C4.33692 9.04091 4.70314 8.40078 4.47664 8.05347C4.25014 7.70615 3.51669 7.78316 2.83844 8.22548C2.16019 8.6678 1.79397 9.30792 2.02046 9.65524C2.24696 10.0026 2.98041 9.92554 3.65867 9.48323Z"
          fill="url(#paint10_radial_4706_230191)"
        />
        <path
          d="M18.7772 9.18433C17.8077 8.09488 15.6745 7.30269 15.11 7.80464C14.5311 8.31988 15.1542 10.596 16.0538 11.6078C16.6991 12.3332 17.8327 12.3793 18.5842 11.7097C19.3362 11.0406 19.4225 9.90972 18.7768 9.18433H18.7772Z"
          fill="url(#paint11_radial_4706_230191)"
        />
        <path
          d="M18.7772 9.18433C17.8077 8.09488 15.6745 7.30269 15.11 7.80464C14.5311 8.31988 15.1542 10.596 16.0538 11.6078C16.6991 12.3332 17.8327 12.3793 18.5842 11.7097C19.3362 11.0406 19.4225 9.90972 18.7768 9.18433H18.7772Z"
          fill="url(#paint12_radial_4706_230191)"
        />
        <path
          d="M18.7772 9.18433C17.8077 8.09488 15.6745 7.30269 15.11 7.80464C14.5311 8.31988 15.1542 10.596 16.0538 11.6078C16.6991 12.3332 17.8327 12.3793 18.5842 11.7097C19.3362 11.0406 19.4225 9.90972 18.7768 9.18433H18.7772Z"
          fill="url(#paint13_radial_4706_230191)"
        />
        <path
          d="M18.0153 9.67884C18.2418 9.33152 17.8682 8.68661 17.1809 8.23839C16.4936 7.79018 15.7528 7.70838 15.5263 8.0557C15.2998 8.40301 15.6734 9.04792 16.3607 9.49614C17.048 9.94436 17.7888 10.0262 18.0153 9.67884Z"
          fill="url(#paint14_radial_4706_230191)"
        />
        <path
          d="M10.0423 9.16797C8.41677 9.16797 6.87533 9.40862 5.94834 9.9109C5.68496 10.0536 5.53443 10.2674 5.56429 10.5445C5.68309 11.6468 6.34791 14.4038 10.0266 14.4038C13.7054 14.4038 14.3702 11.6468 14.489 10.5445C14.5189 10.2674 14.3548 10.0471 14.105 9.9109C13.1834 9.40863 11.801 9.16797 10.0423 9.16797Z"
          fill="url(#paint15_radial_4706_230191)"
        />
        <path
          opacity="0.8"
          d="M10.0423 9.16797C8.41677 9.16797 6.87533 9.40862 5.94834 9.9109C5.68496 10.0536 5.53443 10.2674 5.56429 10.5445C5.68309 11.6468 6.34791 14.4038 10.0266 14.4038C13.7054 14.4038 14.3702 11.6468 14.489 10.5445C14.5189 10.2674 14.3548 10.0471 14.105 9.9109C13.1834 9.40863 11.801 9.16797 10.0423 9.16797Z"
          fill="#341C3C"
        />
        <path
          opacity="0.8"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.8182 9.67048C6.80641 9.13504 8.40399 8.89453 10.0425 8.89453C11.8165 8.89453 13.2541 9.13569 14.2359 9.67081C14.5467 9.84018 14.8066 10.1507 14.761 10.5738C14.6991 11.1483 14.4942 12.1708 13.8091 13.055C13.1132 13.953 11.9453 14.6772 10.0268 14.6772C8.10822 14.6772 6.94037 13.953 6.24448 13.055C5.55933 12.1708 5.35446 11.1483 5.29255 10.5738C5.24729 10.1539 5.48967 9.84849 5.8182 9.67048ZM5.94846 9.9109C6.87545 9.40862 8.41689 9.16797 10.0425 9.16797C11.8011 9.16797 13.1835 9.40863 14.1051 9.9109C14.3549 10.0471 14.519 10.2674 14.4891 10.5445C14.3703 11.6468 13.7055 14.4038 10.0268 14.4038C6.34803 14.4038 5.68321 11.6468 5.56442 10.5445C5.53455 10.2674 5.68508 10.0536 5.94846 9.9109Z"
          fill="url(#paint16_linear_4706_230191)"
        />
      </g>
      <defs>
        <filter
          id="filter0_f_4706_230191"
          x="-1.96875"
          y="3.74512"
          width="12.0195"
          height="13.5186"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2.5"
            result="effect1_foregroundBlur_4706_230191"
          />
        </filter>
        <filter
          id="filter1_f_4706_230191"
          x="9.92578"
          y="3.70605"
          width="12.0811"
          height="13.627"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="2.5"
            result="effect1_foregroundBlur_4706_230191"
          />
        </filter>
        <radialGradient
          id="paint0_radial_4706_230191"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.76644 3.8012) scale(13.1441)"
        >
          <stop stopColor="#FFF1B6" />
          <stop offset="0.43" stopColor="#FFD400" />
          <stop offset="0.7" stopColor="#FFD400" />
          <stop offset="1" stopColor="#FF8E00" />
        </radialGradient>
        <radialGradient
          id="paint1_radial_4706_230191"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(6.78871 4.06577) rotate(54.7041) scale(13.945 13.929)"
        >
          <stop offset="0.608798" stopColor="#FFE437" stopOpacity="0" />
          <stop offset="0.858784" stopColor="#FF79B1" stopOpacity="0.45" />
          <stop offset="0.994222" stopColor="#FF3673" stopOpacity="0.56" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_4706_230191"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.97558 10.2928) rotate(-90) scale(7.73511 7.38974)"
        >
          <stop offset="0.848958" stopColor="#FFC60C" stopOpacity="0" />
          <stop offset="1" stopColor="#FF7039" stopOpacity="0.68" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_4706_230191"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.97559 9.65249) rotate(90) scale(7.35142 7.28983)"
        >
          <stop offset="0.847356" stopColor="#FE789B" stopOpacity="0" />
          <stop offset="1" stopColor="#F11414" stopOpacity="0.41" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_4706_230191"
          x1="4.93864"
          y1="9.07447"
          x2="3.40159"
          y2="12.0754"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E07900" />
          <stop offset="1" stopColor="#DD5D00" stopOpacity="0.2" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_4706_230191"
          x1="15.0413"
          y1="9.0459"
          x2="16.6252"
          y2="12.1384"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E07900" />
          <stop offset="1" stopColor="#DD5D00" stopOpacity="0.2" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_4706_230191"
          x1="12.9428"
          y1="6.04895"
          x2="12.9428"
          y2="8.22773"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE259" stopOpacity="0" />
          <stop offset="1" stopColor="#FFE794" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_4706_230191"
          x1="7.0299"
          y1="6.04895"
          x2="7.0299"
          y2="8.22773"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFE259" stopOpacity="0" />
          <stop offset="1" stopColor="#FFE794" />
        </linearGradient>
        <radialGradient
          id="paint8_radial_4706_230191"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(3.5494 7.25557) scale(4.69883 4.69883)"
        >
          <stop stopColor="#39D0FF" />
          <stop offset="0.74" stopColor="#00B6FF" />
          <stop offset="1" stopColor="#0089CE" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_4706_230191"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(4.89948 7.96081) rotate(132.026) scale(4.79233 4.79247)"
        >
          <stop stopColor="#39D0FF" />
          <stop offset="0.660954" stopColor="#00B6FF" />
          <stop offset="1" stopColor="#66D1FF" />
        </radialGradient>
        <radialGradient
          id="paint10_radial_4706_230191"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(3.28736 8.85343) rotate(146.89) scale(1.51567 0.748969)"
        >
          <stop stopColor="#C5F1FF" stopOpacity="0.6" />
          <stop offset="1" stopColor="#02ADF5" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint11_radial_4706_230191"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.49 8.1153) rotate(49.8082) scale(4.18261)"
        >
          <stop stopColor="#39D0FF" />
          <stop offset="0.458333" stopColor="#00B6FF" />
          <stop offset="0.901042" stopColor="#0063BF" />
          <stop offset="1" stopColor="#0068C8" />
        </radialGradient>
        <radialGradient
          id="paint12_radial_4706_230191"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.3943 8.28087) rotate(49.7078) scale(4.18106 4.18109)"
        >
          <stop stopColor="#39D0FF" />
          <stop offset="0.512516" stopColor="#00B6FF" />
          <stop offset="1" stopColor="#91DEFF" />
        </radialGradient>
        <radialGradient
          id="paint13_radial_4706_230191"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(15.2603 7.92316) rotate(47.6224) scale(4.95261 4.95267)"
        >
          <stop stopColor="#39D0FF" />
          <stop offset="0.660954" stopColor="#00B6FF" />
          <stop offset="1" stopColor="#66D1FF" />
        </radialGradient>
        <radialGradient
          id="paint14_radial_4706_230191"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(16.7372 8.85755) rotate(33.11) scale(1.53589 0.748969)"
        >
          <stop stopColor="#C5F1FF" stopOpacity="0.6" />
          <stop offset="1" stopColor="#02ADF5" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint15_radial_4706_230191"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(10.5507 12.8849) rotate(-89.4578) scale(3.9786 12.4901)"
        >
          <stop stopColor="#5C1800" />
          <stop offset="1" stopColor="#942A00" />
        </radialGradient>
        <linearGradient
          id="paint16_linear_4706_230191"
          x1="10.0266"
          y1="9.16797"
          x2="10.0266"
          y2="14.4038"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FD9E28" stopOpacity="0.4" />
          <stop offset="1" stopColor="#FFF2B7" />
        </linearGradient>
        <clipPath id="clip0_4706_230191">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
